import { useEffect, useState } from "react";
import { Col, Container } from "react-bootstrap";
import ApiService from "../../../../services/api";
import "../css/follow.css";

const Follow = () => {
  const [follow, setFollow] = useState({});
  const [Loading, setLoading] = useState(true);

  const fetchAlbum = async () => {
    const AlbumList = await ApiService.getFollows();
    setFollow(AlbumList);
    setLoading(false);
  };

  useEffect(() => {
    fetchAlbum();
  }, []);

  if (Loading) {
    return;
  }
  return (
    <Container fluid className="mt-5 pt-5 mb-5 pb-5">
      <Col className="bg-trasparent col-12 container-white_album d-flex justify-content-center align-items-center mt-3 py-3 text-center">
        <Container>
          <h3 className="pb-3 section-title">
            Follow{" "}
            <div className="border-custom mt-3"></div>
          </h3>
          <Col md={{ span: 6, offset: 3 }} className="mb-4 mt-5 pt-3">
            {follow.map(({ id, link, path }) => {
              return (
                <a
                  target="_blank"
                  rel="noreferrer"
                  href={link}
                  key={id}
                  className=""
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    className="mx-3 mx-md-4 my-2 text_color_custom"
                    fill="currentColor"
                    viewBox="0 0 16 16"
                  >
                    <path d={path} />
                  </svg>
                </a>
              );
            })}
          </Col>
        </Container>
      </Col>
    </Container>
  );
};
export default Follow;
